import PessoaDiabetesIcon from '@/components/icons/IndicadoresAps/eSFeAP/PessoaDiabetes.vue'

export default {
  value: 'c4',
  label: 'Pessoa diabética',
  iconType: 'component',
  iconComponent: PessoaDiabetesIcon,
  buscaAtiva: {
    a: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a avaliação de diabetes (em atraso).'
        : 'Realizar e registrar a avaliação de diabetes (em atraso).',
    b: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar a pressão arterial (em atraso).'
        : 'Aferir e registrar a pressão arterial (em atraso).',
    c: 'Acionar o Agente de Saúde para visita domiciliar (em atraso).',
    d: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar peso e altura (em atraso).'
        : 'Aferir e registrar peso e altura (em atraso).',
    e: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para solicitar ou registrar a hemoglobina glicada (em atraso).'
        : 'Solicitar ou avaliar a hemoglobina glicada (em atraso).',
    f: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a avaliação dos pés (em atraso)'
        : 'Realizar e registrar a avaliação dos pés (em atraso).',
  },
}
